import { createFileRoute } from '@tanstack/react-router'
import { JobRoleEditorPage } from '@/features/job-roles/editor'

export const Route = createFileRoute('/job-roles_/$jobRoleId/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  const { jobRoleId } = Route.useParams()
  return <JobRoleEditorPage jobRoleId={jobRoleId} />
}
